import { useTexts } from '../hooks/useTexts'

import { form } from '../formState'

export function Password() {
  const texts = useTexts()

  const validationSummaryItems = form.useStandardPasswordValidations('new-password')

  return (
    <form.Fieldset>
      <form.Password
        name="new-password"
        testId="new-password"
        label={texts.labels.password}
        placeholder={texts.placeholders.password}
        validateOn="blur change"
        errorVisibility="accent-only"
        textfieldProps={{
          autoComplete: 'new-password',
        }}
      />

      <form.ValidationSummary items={validationSummaryItems} mode="show-errors" />
    </form.Fieldset>
  )
}
